import { DisableAction, EnableAction, SetValueAction } from 'ngrx-forms';
import { of } from 'rxjs';
import { catchError, concatMap, map, mergeMap, tap, withLatestFrom } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';

import { selectLoggedUser } from '../../../auth/auth.selectors';
import { AppState } from '../../../core.state';
import { NotificationService } from '../../../notifications/notification.service';
import { CountryCardService } from '../../country-card/country-card.service';
import { Role } from '../../user/role.enum';
import {
    CheckRequirementsActionTypes, LoadValidDocuments, LoadValidDocumentsFail,
    LoadValidDocumentsSuccess, ShowCheckRequirementsPopup
} from './check-requirements.actions';
import { CHECK_REQUIREMENTS_FORM_ID } from './check-requirements.reducers';
import {
    selectCheckRequirementsPeriodFrom, selectCheckRequirementsPeriodTo,
    selectCheckRequirementsUserId
} from './check-requirements.selectors';

@Injectable()
export class CheckRequirementsEffects {
    constructor(
        private service: CountryCardService,
        private actions$: Actions,
        private notificationService: NotificationService,
        private store: Store<AppState>
    ) {
    }

    @Effect({ dispatch: false })
    genericFail$ = this.actions$.pipe(
        ofType<Action & { payload: string }>(
            CheckRequirementsActionTypes.LoadValidDocumentsFail,
        ),
        tap(action => this.notificationService.error(action.payload))
    );

    @Effect({ dispatch: false })
    showCheckRequirements$ = this.actions$.pipe(
        ofType<ShowCheckRequirementsPopup>(CheckRequirementsActionTypes.ShowCheckRequirementsPopup),
        withLatestFrom(this.store.select(selectLoggedUser)),
        tap(([a, loggedUser]) => {
            const userIdControlId = CHECK_REQUIREMENTS_FORM_ID + '.userId';
            const countryIdControlId = CHECK_REQUIREMENTS_FORM_ID + '.countryId';
            let userId = a.userId;
            if (loggedUser.role === Role.Freelance) {
                userId = loggedUser.id;
            }
            if (userId) {
                this.store.dispatch(new DisableAction(userIdControlId));
            } else {
                this.store.dispatch(new EnableAction(userIdControlId));
            }

            this.store.dispatch(new SetValueAction(userIdControlId, userId));
            this.store.dispatch(new SetValueAction(countryIdControlId, a.countryId));
        })
    );


    // @Effect()
    // userIdChange$ = this.actions$.pipe(
    //     ofType<SetValueAction<number>>(SetValueAction.TYPE),
    //     filter(action => (action.controlId === CHECK_REQUIREMENTS_FORM_ID + '.userId') && !!action.value),
    //     map(a => new LoadValidDocuments())
    // );

    @Effect()
    loadValidDocuments$ = this.actions$.pipe(
        ofType<LoadValidDocuments>(CheckRequirementsActionTypes.LoadValidDocuments),
        concatMap(action => of(action).pipe(
            withLatestFrom(
                this.store.select(selectCheckRequirementsUserId),
                this.store.select(selectCheckRequirementsPeriodFrom),
                this.store.select(selectCheckRequirementsPeriodTo)
            )
        )),
        mergeMap(([action, userId, from, to]) =>
            this.service.getValidDocuments(userId, from, to).pipe(
                map(items => (new LoadValidDocumentsSuccess(items))),
                catchError(err => of(new LoadValidDocumentsFail(err)))
            )
        )
    );

}
